import { Link } from "react-router-dom";
import { Instagram, Linkedin, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-black text-white pt-6 md:pt-16 pb-6 md:pb-8 px-6 md:px-12 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute -top-10 right-10 font-script text-[#F42B29] text-5xl rotate-[-8deg] hidden md:block select-none">saucin&apos;</div>

      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-7">
          <p className="font-body uppercase text-xs tracking-[0.2em] text-white/50 mb-4 md:mb-6">Sauce Studios</p>
          <h2 className="font-display uppercase tracking-mega leading-[0.92] text-[clamp(1.65rem,6.5vw,4rem)] md:text-[clamp(3rem,6.5vw,6rem)] xl:text-[clamp(3.75rem,7vw,7.5rem)] max-w-4xl">
            <span className="inline md:block">saucin&apos; up</span>{" "}
            <span className="inline md:block">your content<span className="text-[#F42B29]">.</span></span>
          </h2>
        </div>

        <div className="col-span-12 mt-8 md:mt-0 grid grid-cols-2 gap-x-6 md:contents">
          <div className="md:col-span-2 md:mt-2">
            <p className="font-body uppercase text-xs tracking-[0.2em] text-white/50 mb-3 md:mb-4">Studio</p>
            <ul className="space-y-2 font-body text-[13.5px] md:text-base">
              <li><Link className="link-line" to="/work" data-testid="footer-link-work">Work</Link></li>
              <li><Link className="link-line" to="/about" data-testid="footer-link-about">About</Link></li>
              <li><Link className="link-line" to="/process" data-testid="footer-link-process">Process</Link></li>
              <li><Link className="link-line" to="/contact" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3 md:mt-2 min-w-0">
            <p className="font-body uppercase text-xs tracking-[0.2em] text-white/50 mb-3 md:mb-4">Contact</p>
            <ul className="space-y-2 font-body text-[13.5px] md:text-base">
              <li><a className="link-line break-words" href="mailto:infosaucestudios@gmail.com" data-testid="footer-email">infosaucestudios@gmail.com</a></li>
              <li><a className="link-line" href="tel:+919983341510" data-testid="footer-phone">+91 99833 41510</a></li>
              <li className="text-white/60">Jodhpur, Rajasthan</li>
            </ul>
            <div className="mt-4 md:mt-6 flex items-center gap-4">
              <a aria-label="Instagram" href="https://instagram.com" className="hover:text-[#F42B29] transition-colors" data-testid="footer-social-instagram"><Instagram className="w-5 h-5" /></a>
              <a aria-label="LinkedIn" href="https://linkedin.com" className="hover:text-[#F42B29] transition-colors" data-testid="footer-social-linkedin"><Linkedin className="w-5 h-5" /></a>
              <a aria-label="YouTube" href="https://youtube.com" className="hover:text-[#F42B29] transition-colors" data-testid="footer-social-youtube"><Youtube className="w-5 h-5" /></a>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 pt-4 md:mt-12 md:pt-5 border-t border-white/10 flex flex-col md:flex-row gap-2 md:gap-4 items-start md:items-center justify-between text-[10px] md:text-xs uppercase tracking-[0.2em] font-body text-white/40">
        <span>&copy; {new Date().getFullYear()} Sauce Studios. All frames reserved.</span>
        <span>Made with <span className="text-[#F42B29]">♥</span> in Jodhpur</span>
      </div>
    </footer>
  );
}
